import React from "react";
import { motion } from "framer-motion";
import { ShieldAlert, UserCheck, Activity, Bot, CheckCircle2, AlertTriangle } from "lucide-react";

const ICONS = {
  violation: ShieldAlert,
  review: UserCheck,
  runtime: Activity,
  agent: Bot,
};
const TONE = {
  critical: "#EF4444",
  warning: "#F59E0B",
  info: "#5B8DEF",
  success: "#22C55E",
};

export default function EventFeed({ events, title = "Recent Events", limit, connected }) {
  const items = limit ? events.slice(0, limit) : events;
  return (
    <div className="card-eco p-6" data-testid="event-feed">
      <div className="mb-4 flex items-center justify-between">
        <div>
          <div className="text-[10px] font-semibold uppercase tracking-[0.18em] text-slate-400">
            {title}
          </div>
          <div className="mt-1 font-display text-lg text-slate-100">Live activity</div>
        </div>
        <div className="flex items-center gap-1.5 text-[11px] text-slate-400" data-testid="live-indicator">
          <span className="relative flex h-1.5 w-1.5">
            <span className={`absolute inline-flex h-full w-full ${connected ? "animate-ping" : ""} rounded-full ${connected ? "bg-emerald-400" : "bg-slate-500"} opacity-60`} />
            <span className={`relative inline-flex h-1.5 w-1.5 rounded-full ${connected ? "bg-emerald-400" : "bg-slate-500"}`} />
          </span>
          {connected ? "streaming · WS" : "connecting…"}
        </div>
      </div>

      <ul className="space-y-2">
        {items.map((e, i) => {
          const Icon = ICONS[e.type] || Activity;
          const color = TONE[e.severity] || TONE.info;
          const isLive = String(e.id).startsWith("live-") || String(e.id).startsWith("ws-");
          return (
            <motion.li
              key={e.id}
              layout
              initial={{ opacity: 0, x: isLive ? -16 : -8, scale: isLive ? 0.98 : 1 }}
              animate={{ opacity: 1, x: 0, scale: 1 }}
              transition={{ duration: 0.35, delay: isLive ? 0 : 0.03 * i }}
              className={`flex items-start gap-3 rounded-lg border px-3 py-2.5 ${
                isLive ? "border-[#5B8DEF]/30 bg-[#5B8DEF]/[0.04]" : "border-transparent hover:border-white/5 hover:bg-white/[0.02]"
              }`}
            >
              <div
                className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-lg"
                style={{ background: `${color}1A`, border: `1px solid ${color}33`, color }}
              >
                <Icon size={14} strokeWidth={1.7} />
              </div>
              <div className="flex-1">
                <div className="text-[13px] text-slate-200">{e.title}</div>
                <div className="mt-0.5 text-[11px] text-slate-500">
                  {e.agent} · {e.time}
                </div>
              </div>
              {isLive && (
                <span className="rounded-full bg-emerald-400/15 px-1.5 py-0.5 text-[9px] uppercase tracking-wider text-emerald-300">
                  new
                </span>
              )}
            </motion.li>
          );
        })}
      </ul>
    </div>
  );
}
